import React, { useState } from 'react'
import { NumberFormatValues } from 'react-number-format'
import Flex from 'typescript-styled-flex'
import { FiRefreshCw } from 'react-icons/fi'
import { deformatNumber } from '../../../../utils/Money'
import FormElement, { IFormElementProps } from '../../FormElement/FormInput'
import Currency from '../../PriceInput/Currency'
import AddButton from '../../../AddButton'
import { theme } from '../../../../theme'
import SpinningIcon from '../../../Template/SpinningIcon'
import CalculatorIcon from '../../../../assets/icons/calculator.png'
import { PriceFormat } from '../index'
import Input from './Input'
import { PopoveredIcon2 } from '../../../PopoveredIcon/PopoveredIcon'
import UpgradePremiumBlockScreenModal
  from '../../../../containers/UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'
import { useMediaQuery, useTheme } from '@material-ui/core'

const MainPrice = FormElement(
  ({
    name,
    placeholder,
    isSelected,
    errorMsg,
    warningMsg,
    onChange,
    onFocus,
    onBlur,
    required,
    size = 1,
    value,
    disabled,
    alignCenter = false,
    className,
    currency,
    inputStyle,
    onCalculate,
    isSmallReservation,
    onRefresh,
    isCalculating,
     isSideButtonDisabled,
  }: IFormElementProps) => {
    function change(values: NumberFormatValues) {
      onChange(values.value)
    }

    function blur(e) {
      e.name = name
      if (onBlur) {
        const nextVal = !value ? '0.00' : deformatNumber(value) //Fix for redux form
        if (e.currentTarget) {
          e.currentTarget.value = nextVal
        }
        e.target.value = nextVal
        onBlur(e)
      }
    }

    const theme2 = useTheme()
    const isMobile = useMediaQuery(theme2.breakpoints.down('sm'))
    const [isModalOpened, setIsModalOpened] = useState(false)
    const [popoverAnchor, setPopoverAnchor] = useState(null)

    const handlePopoverOpen = event => {
      if (isMobile) {
        setIsModalOpened(true)
      } else {
        event.preventDefault()
        event.stopPropagation()
        setPopoverAnchor(event.currentTarget)
      }
    }

    const handlePopoverClose = event => {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      setPopoverAnchor(null)
    }

    return (
      <Flex
        justifyEnd={true}
        alignStart={!alignCenter}
        alignCenter={alignCenter}
        style={{ position: 'relative' }}
      >
        <PriceFormat
          customInput={Input}
          onValueChange={change}
          value={value.replace(',', '.')}
          name={name}
          isNumericString={true}
          style={{ ...{ textAlign: 'right', backgroundColor: disabled ? 'white' : undefined }, ...inputStyle }}
          placeholder={placeholder}
          selected={isSelected}
          error={errorMsg && errorMsg !== ''}
          warning={warningMsg && warningMsg !== ''}
          type={'text'}
          onFocus={onFocus}
          size={size}
          required={required}
          inputMode={'numeric'}
          disabled={disabled}
          className={className}
          onBlur={blur}
          smallReservation={isSmallReservation}
          allowNegative={false}
        />
        <Flex
          style={{
            position: 'absolute',
            right: `${48 * size}px`,
            top: `${11 * size}px`,
          }}
        >
          <Currency size={size}>{currency}</Currency>
        </Flex>
        <AddButton
          color={
            warningMsg
              ? theme.colors.palette.tangerine
              : theme.colors.palette.emerald
          }
          style={{
            borderRadius: '0px 3px 3px 0px',
            height: `${38 * size}px`,
            minWidth: `${38 * size}px`,
            width: `${38 * size}px`,
          }}
          isDisabled={isSideButtonDisabled}
          onClick={disabled || isSideButtonDisabled ? handlePopoverOpen :isCalculating ? onRefresh : onCalculate}
        >
          {isCalculating ? (
            <SpinningIcon size={16 * size} />
          ) : warningMsg ? (
            <FiRefreshCw size={16 * size} />
          ) : (
            <img
              style={{
                filter:
                  'invert(100%) sepia(25%) saturate(729%) hue-rotate(212deg) brightness(109%) contrast(101%)',
              }}
              width={24 * size}
              height={24 * size}
              src={CalculatorIcon}
              alt={'main price'}
            />
          )}
        </AddButton>
        <PopoveredIcon2
          withIcon={false}
          anchorEl={popoverAnchor}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        />
        {isMobile && <UpgradePremiumBlockScreenModal
          open={isModalOpened}
          close={() => setIsModalOpened(false)}
        />}
      </Flex>
    )
  },
)

export { MainPrice }
